import { Result } from 'domain/types';
import ReadPresetFormClient from 'use-case/presets/form/readPresetFormClient';
import ReadPresetFormCriteria from 'use-case/presets/form/readPresetFormCriteria';
import PresetForm from 'domain/entity/preset/form/presetForm';

export type PresetFormResult = Result<PresetForm>;
export type ReadSelectorValues = (criteria: ReadPresetFormCriteria) => Promise<PresetFormResult>;

export default (readPresetFormClient: ReadPresetFormClient): ReadSelectorValues => (
    criteria: ReadPresetFormCriteria
): Promise<PresetFormResult> => readPresetFormClient(criteria);
